// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"d1a727b0","536":"d1a727b0","547":"d1a727b0"}[chunkId] + ".chunk.css";
};